<section class="a-drs-cell-container flex-v hpct100 pct100 abs l0 t0 bg-white">
    <div class="tc f16 pt12">
        <i class="fas fa-chevron-up poi"
            [ngClass]="{'poi':!previousBtnDisabled,'disabled-text-color pointer-events-none':previousBtnDisabled}"
            (click)="previousYearList()"></i>
    </div>
    <div class="f-g f-s hpct100">
        <ul class="flex-h-c f-wrap hpct100 pct100">
            <li *ngFor="let year of yearList" class="poi"
                [ngClass]="{'a-drs-disabled pointer-events-none':year<minYear||year>maxYear,'a-drs-active':year==activeYear}">
                <div class="flex-vh-c" (click)="yearClick(year)">{{year}}</div>
            </li>
        </ul>
    </div>
    <div class="tc f16 pb12">
        <i class="fas fa-chevron-down poi"
            [ngClass]="{'poi':!nextBtnDisabled,'disabled-text-color pointer-events-none':nextBtnDisabled}"
            (click)="nextYearList()"></i>
    </div>
</section>